import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Choices from 'choices.js';

const mql = window.matchMedia('(min-width: 768px)');

document.querySelectorAll('.js-program-search').forEach(($programSearch) => {
  const $steps = Array.prototype.slice.call($programSearch.querySelectorAll('.program-search__step'));
  const $selects = Array.prototype.slice.call($programSearch.querySelectorAll('.select'));
  const $submit = $programSearch.querySelector('.program-search__submit');
  const disabledClass = 'program-search__step--disabled';
  const programSearchRect = $programSearch.getBoundingClientRect();

  // Initialize custom select
  $selects.forEach((e) => {
    const choices = new Choices(e, { // eslint-disable-line
      searchEnabled: false,
      shouldSort: false,
      classNames: {
        containerOuter: 'choices select',
      },
    });

    e.addEventListener('showDropdown', (event) => {
      if (!mql.matches) {
        // Disable Body scrolling
        disableBodyScroll(event.target);
      }
    }, false);

    e.addEventListener('hideDropdown', (event) => {
      if (!mql.matches) {
        // Enable Body scrolling
        enableBodyScroll(event.target);
      }
    }, false);
  });

  // Set elements initially disabled
  $steps.forEach(($step) => {
    const $select = $step.querySelector('.select');

    $step.classList.add(disabledClass);
    $select.disabled = true;
  });

  // Position custom select
  $programSearch.querySelectorAll('.choices__list--dropdown').forEach(($el) => {
    const $dropdown = $el;

    if (mql.matches) {
      const dropdownRect = $dropdown.getBoundingClientRect();
      const topPosition = dropdownRect.top - programSearchRect.top;
      $dropdown.style.height = `${programSearchRect.height}px`;
      $dropdown.style.top = `-${topPosition}px`;
    }
  });

  $submit.disabled = true;

  // Set first step active
  $steps[0].classList.remove(disabledClass);
  $steps[0].querySelector('.select').disabled = false;

  $steps.forEach(($step) => {
    const $nextStep = $step.nextElementSibling;

    $step.querySelector('.select').addEventListener('change', () => {
      // Activate next step
      if ($nextStep && $nextStep.classList.contains(disabledClass)) {
        $nextStep.classList.remove(disabledClass);
        $nextStep.querySelector('.select').disabled = false;
      // Activate submit
      } else if (!$nextStep && $submit.disabled) {
        $submit.disabled = false;
      }
    });
  });
});
